export * from '@aurora/components/template-dialog/public-api';
